function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0.6241 20.519c0-10.48 8.7016-19.027 19.414-19.027 10.751 0 19.414 8.5468 19.414 19.027 0 10.519-8.6629 19.027-19.414 19.027-10.713 0-19.414-8.5081-19.414-19.027z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.6241 20.519c0-10.48 8.7016-19.027 19.414-19.027 10.751 0 19.414 8.5468 19.414 19.027 0 10.519-8.6629 19.027-19.414 19.027-10.713 0-19.414-8.5081-19.414-19.027",
  fill: "none",
  stroke: "#002060",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-secondary",
  d: "m20.116 8.1438 11.757 7.5026 0.03867 0.03867 0.38674 0.23204h-0.03867l0.19337 0.11602c0.30939 0.30938 0.50276 0.77346 0.50276 1.2762v11.795c0 1.0055-0.77347 1.779-1.779 1.779h-22.083c-1.0055 0-1.8177-0.77346-1.8177-1.779v-11.795c0-0.50275 0.23204-0.96683 0.54143-1.2762l0.19337-0.11602h-0.038674l0.38674-0.23204 0.038674-0.03867z",
  fill: "#adb9ca",
  fillRule: "evenodd"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m20.053 8.1438 11.469 7.378v0l0.03772 0.03803 0.37725 0.22818h-0.03772l0.18863 0.11409c0.3018 0.30424 0.49043 0.76062 0.49043 1.255v11.599c0 0.9888-0.75451 1.7494-1.7354 1.7494h-21.541c-0.98086 0-1.7731-0.76061-1.7731-1.7494v-11.599c0-0.4944 0.22635-0.95077 0.52816-1.255l0.18863-0.11409h-0.037726l0.37725-0.22818 0.037726-0.03803v0z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-primary",
  d: "m12.256 7.5251h15.6c0.43234 0 0.75659 0.38673 0.75659 0.85081v9.4749l-8.5747 5.2982-8.5747-5.2596v-9.5136c0-0.46408 0.36028-0.85081 0.79262-0.85081z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8
}, React.createElement("path", {
  d: "m9.7219 16.872 1.5906 0.95256"
}), React.createElement("path", {
  d: "m10.266 28.415 7.2797-4.2037"
}), React.createElement("path", {
  d: "m30.381 16.683-1.5906 0.95256"
}), React.createElement("path", {
  d: "m28.705 28.353-6.5733-4.1432"
}));

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m12.253 7.5251h15.543c0.43075 0 0.75381 0.38673 0.75381 0.85081v9.4749l-8.5432 5.2982-8.5432-5.2596v-9.5136c0-0.46408 0.35896-0.85081 0.78971-0.85081z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 =
/*#__PURE__*/
React.createElement("tspan", {
  x: 14.520451,
  y: 17.87191,
  strokeWidth: 0.5
}, "@");

var SvgDefineSurveyTabTestEmails = function SvgDefineSurveyTabTestEmails(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, React.createElement("text", {
    className: "icon-tertiary",
    x: 14.520451,
    y: 17.87191,
    fill: "#002060",
    fontFamily: "'Segoe UI'",
    fontSize: "11.25px",
    letterSpacing: "0px",
    wordSpacing: "0px",
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _ref9));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDefineSurveyTabTestEmails, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Define-Survey-Tab-TestEmails.bd92cbb4.svg";
export { ForwardRef as ReactComponent };